/**
 * PWA install prompt helper.
 *
 * Captures the `beforeinstallprompt` event and exposes a small API to trigger
 * the install prompt on user action. Also exposes a listener to know whether
 * the PWA is already installed (standalone display mode).
 */
let deferredPrompt = null;
const listeners = new Set();

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault();
    deferredPrompt = e;
    listeners.forEach((fn) => fn({ type: 'available' }));
  });
  window.addEventListener('appinstalled', () => {
    deferredPrompt = null;
    listeners.forEach((fn) => fn({ type: 'installed' }));
  });
}

export function isInstalled() {
  if (typeof window === 'undefined') return false;
  if (window.matchMedia?.('(display-mode: standalone)').matches) return true;
  if (window.navigator.standalone) return true; // iOS
  return false;
}

export function canInstall() {
  return !!deferredPrompt;
}

export function subscribeInstall(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export async function promptInstall() {
  if (!deferredPrompt) return 'unavailable';
  deferredPrompt.prompt();
  const { outcome } = await deferredPrompt.userChoice;
  deferredPrompt = null;
  return outcome; // 'accepted' | 'dismissed'
}
